/* ==========================================================================
   GEGE content sections — shared behaviour

   The AI-generated blocks each defined their own custom element named after
   the block id, so every instance shipped its own copy of the same script and
   most of those classes had an empty constructor and did nothing at all.

   Only one component needs JavaScript: the mosaic gallery lightbox. It is
   defined once here and works for any number of instances on a page.
   ========================================================================== */
(function () {
  'use strict';

  if (customElements.get('gg-mosaic')) return;

  class GgMosaic extends HTMLElement {
    connectedCallback() {
      this.lightbox = this.querySelector('.gg-mosaic__lightbox');
      this.lightboxImage = this.querySelector('.gg-mosaic__lightbox-image');
      this.closeButton = this.querySelector('.gg-mosaic__lightbox-close');
      if (!this.lightbox || !this.lightboxImage || !this.closeButton) return;

      this.lastFocused = null;
      this.onKeydown = this.onKeydown.bind(this);

      this.querySelectorAll('.gg-mosaic__item').forEach((item) => {
        const image = item.querySelector('.gg-mosaic__image');
        if (!image) return;

        item.setAttribute('tabindex', '0');
        item.setAttribute('role', 'button');
        item.setAttribute('aria-label', image.getAttribute('alt') || 'View larger image');

        item.addEventListener('click', () => this.open(image));
        item.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.open(image);
          }
        });
      });

      this.closeButton.addEventListener('click', () => this.close());
      this.lightbox.addEventListener('click', (event) => {
        if (event.target === this.lightbox) this.close();
      });
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKeydown);
    }

    onKeydown(event) {
      if (event.key === 'Escape') this.close();
    }

    open(image) {
      this.lastFocused = document.activeElement;
      this.lightboxImage.src = image.getAttribute('data-full-src') || image.src;
      this.lightboxImage.alt = image.getAttribute('alt') || '';
      this.lightbox.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', this.onKeydown);
      this.closeButton.focus();
    }

    close() {
      this.lightbox.classList.remove('is-open');
      // Only release the scroll lock if no other gallery still has one open.
      if (!document.querySelector('.gg-mosaic__lightbox.is-open')) {
        document.body.style.overflow = '';
      }
      document.removeEventListener('keydown', this.onKeydown);
      if (this.lastFocused && typeof this.lastFocused.focus === 'function') {
        this.lastFocused.focus();
      }
    }
  }

  customElements.define('gg-mosaic', GgMosaic);
})();
